import React from "react";
import { Link } from "gatsby";
import ReviewSvg from "assets/images/review_stars.svg";
import HomepageReviewCards from "components/homepage/HomepageReviewCard";
import GlobalFixContactus from "components/reusableComponents/GlobalFixContactus";
import OptimizedImage from "hooks/OptimizedImage";

const ThirdFrench = (Data) => {
  return (
    <div className="pt-24 bg-gradient-to-b from-[white] to-[#E8F1F5]">
      <div className="w-full mx-auto flex flex-col justify-center">
        <h3 className="text-[40px] font-secondary font-semibold text-[#00173A] text-center">
          {Data.data.title_block_3}
        </h3>
        <div className="">
          {/* <ul className="div w-full sm:gap-x-4 2xl:gap-x-3 flex lg:flex-row flex-col justify-center items-center lg:relative pt-6 lg:pt-14">
            <li className="logos flex flex-col items-center w-[175px] pt-6 lg:pt-0">
              <img src={ISO} alt="" className="lg:pb-12" />
              <div className=" lg:absolute lg:bottom-0 ">
                <p className="text-[14px] text-[#313E5A] pt-4  text-center">
                  ISO 9001:2015
                </p>
                <p className="text-[14px] text-[#313E5A] text-center">
                  {" "}
                  Certification No. 108179{" "}
                </p>
              </div>
            </li>
            <li className="logos flex flex-col items-center w-[175px] pt-6 lg:pt-0">
              <img src={ISO2} alt="" className="lg:pb-12" />
              <div className=" lg:absolute lg:bottom-0 ">
                <p className="text-[14px] text-[#313E5A] pt-4  text-center">
                  ISO 18587:2017{" "}
                </p>
                <p className="text-[14px] text-[#313E5A] text-center">
                  Certification No. 001259{" "}
                </p>
              </div>
            </li>
            <li className="logos flex flex-col items-center w-[175px] pt-6 lg:pt-0 sm:pb-0 pb-4">
              <img src={ISO3} alt="" className="lg:pb-12" />
              <div className=" lg:absolute lg:bottom-0 ">
                <p className="text-[14px] text-[#313E5A] pt-4  text-center">
                  ISO 17100:2015{" "}
                </p>
                <p className="text-[14px] text-[#313E5A] text-center">
                  Certification No. 001258{" "}
                </p>
              </div>
            </li>
            <li className="logos flex flex-col items-center w-[175px]">
              <img src={ATA} alt="" className="lg:pb-12" />
              <div className="  lg:absolute lg:bottom-0">
                <p className="text-[14px] text-[#313E5A] pt-4  text-center ">
                  ATA Corporate
                </p>
                <p className="text-[14px] text-[#313E5A] text-center ">
                  Member Number 272444
                </p>
              </div>
            </li>

            <li className="logos flex flex-col items-center w-[175px] pt-6 lg:pt-0">
              <Link to="https://clutch.co/translation/leaders-matrix">
                <img
                  src={CLUTCH}
                  alt=""
                  className="flex justify-center mx-auto"
                />
                <div className="">
                  <p className="text-[14px] text-[#313E5A] pt-4  text-center">
                    Clutch Top Global
                  </p>
                  <p className="text-[14px] text-[#313E5A] text-center">
                    Translation Services 2021{" "}
                  </p>
                </div>
              </Link>
            </li>
            <li className="logos flex flex-col items-center w-[175px] pt-6 lg:pt-0">
              <Link
                to="/uscis-translation-services"
                className="logos flex flex-col items-center w-[175px] pt-6 lg:pt-0"
              >
                <img src={USCIS} alt="" className="lg:pb-12 pb-4" />
                <div className="lg:absolute lg:bottom-0">
                  <p className="text-[14px] text-[#313E5A]  text-center">
                    100% guaranteed
                  </p>
                  <p className="text-[14px] text-[#313E5A] text-center">
                    acceptance by USCIS{" "}
                  </p>
                </div>
              </Link>
            </li>
          </ul> */}


          <ul className="div w-full gap-x-[6.75rem] flex lg:flex-row flex-col justify-center items-center lg:relative pt-6 lg:pt-14">
          <li className="logos flex flex-col items-center w-[175px] pt-6 lg:pt-0">
            <OptimizedImage
              src="	https://www.tomedes.com/static/9001-da0972656b253aad9080ecef8f1922e1.webp"
              alt="ISO 9001:2015"
              className="lg:pb-12 w-[10rem] h-auto"
            />
            <div className=" lg:absolute lg:bottom-[-37px] w-[202px]">
              <p className="text-[18px] font-sans font-medium text-[#313E5A] pt-4  text-center">
                ISO 9001:2015
              </p>
              <p className="text-[18px] font-sans font-bold text-[#313E5A] text-center">
                {" "}
                Quality Management Systems
              </p>
            </div>
          </li>
          <li className="logos flex flex-col items-center w-[175px] pt-6 lg:pt-0">
            <OptimizedImage
              src="https://www.tomedes.com/static/17100-0ff9c3017e6dba8263d7287b8d9e2c9b.webp"
              alt="ISO 18587:2017"
              className="lg:pb-12 w-[10rem] h-auto"
            />
            <div className=" lg:absolute lg:bottom-[-37px] w-[202px]">
              <p className="text-[18px] font-sans font-medium text-[#313E5A] pt-4  text-center">
                ISO 17100:2015{" "}
              </p>
              <p className="text-[18px] font-sans font-bold text-[#313E5A] text-center">
                Translation Services Quality
              </p>
            </div>
          </li>
          <li className="logos flex flex-col items-center w-[175px] pt-6 lg:pt-0 sm:pb-0 pb-4">
            <OptimizedImage
              src="	https://www.tomedes.com/static/18587-a1c764d0ddf5cec6cfbeef6f79744ba9.webp"
              alt="ISO 17100:2015"
              className="lg:pb-12 w-[10rem] h-auto"
            />
            <div className=" lg:absolute lg:bottom-[-37px] w-[202px]">
              <p className="text-[18px] font-sans font-medium text-[#313E5A] pt-4  text-center">
                ISO 18587:2017{" "}
              </p>
              <p className="text-[18px] font-sans font-bold text-[#313E5A] text-center">
                Post-editing Machine Translation Output
              </p>
            </div>
          </li>
        </ul>

        </div>
      </div>
      <section className="pb-16 mx-auto pt-36 sm:pt-48">
        <div className="container mx-auto px-4 max-w-6xl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 justify-items-end	">
            <div>
              <h3 className="font-secondary text-40 font-bold">
                <span className="text-[#00173A]">See what our customers </span>

                <br />
                <span className="text-midBlue">
                  think about our translation services
                </span>
              </h3>
              <img src={ReviewSvg} alt="review star" className="mt-5 mb-2" />
              <p className="font-opensans text-17 text-midBlue text-left mt-5">
                Tomedes takes pride in 95,000+ satisfied customers, around the
                globe, a number that includes several Fortune 500 companies. We
                have a 4.9 out of 5 aggregate star rating from
                <span className="font-bold">1,798 online reviews.</span>
              </p>
              <p className="mt-12 mb-12 md:mb-0">
                <Link
                  to="/reviews.php"
                  className="uppercase rounded-full bg-orange hover:bg-[#ff9a16] text-white cursor-pointer text-17 font-opensans font-semibold py-4 px-8 w-[253px] text-center transition-all duration-300 "
                >
                  SEE ALL REVIEWS
                </Link>
              </p>
            </div>
            <HomepageReviewCards />
          </div>
        </div>
      </section>
      <GlobalFixContactus
        head={Data.data.translate_now_title}
        para=" "
        btnName="Translate Now"
        link="/quote"
      />
    </div>
  );
};

export default ThirdFrench;
